import React, { useEffect, useState } from 'react'
import * as api from '../api/api'
import { IconArrowRight } from './Icons'

const SkillArea = ({ skills: propSkills }) => {
    const [skills, setSkills] = useState([]);

    useEffect(() => {
        if (propSkills && propSkills.length > 0) {
            setSkills(propSkills);
            return;
        }

        const fetchSkills = async () => {
            try {
                const { data } = await api.fetchSkills();
                setSkills(data);
            } catch (error) {
                console.error("Failed to fetch skills", error);
            }
        };
        fetchSkills();
    }, [propSkills]);

    return (
        <div>
            <section id="skills" className="skill-area rel z-1">
                <div className="for-bgc-black py-50">
                    <div className="container">
                        <div className="row gap-100">
                            <div className="col-lg-5">
                                <div className="skill-content-part rel z-2 rmb-55 wow fadeInUp delay-0-2s">
                                    <div className="section-title mb-40">
                                        <span className="sub-title mb-15" style={{ color: '#38BDF8', fontWeight: 600 }}>Technical Expertise</span>
                                        <h2 style={{ color: '#F8FAFC', fontWeight: 800 }}>Explore Core <span>Skills & Stack</span></h2>
                                        <p style={{ color: '#94A3B8', fontSize: '16px', lineHeight: '1.7' }}>
                                            Specialized in architecting high-performance web applications, enterprise database systems, and desktop solutions using MERN stack, Next.js, TypeScript, MySQL, and Python.
                                        </p>
                                    </div>
                                    <a href="#contact" className="btn-executive-primary">Hire Me <IconArrowRight className="ms-2" /></a>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="skill-items-wrap">
                                    <div className="row g-3">
                                        {skills.length > 0 ? (
                                            skills.map((skill, index) => (
                                                <div key={skill._id || index} className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6">
                                                    <div className="skill-item executive-card text-center p-3">
                                                        <img
                                                            src={api.getImageUrl(skill.image)}
                                                            alt={skill.name}
                                                            style={{ maxHeight: "38px", width: "auto", objectFit: 'contain' }}
                                                            className="mb-2"
                                                        />
                                                        <h5 style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600 }} className="my-1">{skill.name}</h5>
                                                        <span className="percent" style={{ color: '#38BDF8', fontSize: '13px', fontWeight: 700 }}>{String(skill.percentage || '').replace(/%/g, '')}%</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            /* 8 Skeleton Skill Card Placeholders */
                                            [...Array(8)].map((_, i) => (
                                                <div key={i} className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6">
                                                    <div className="skill-item executive-card text-center p-3 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '120px' }}>
                                                        <div className="skeleton-shimmer skeleton-circle mb-2"></div>
                                                        <div className="skeleton-shimmer skeleton-line w-75 mb-2"></div>
                                                        <div className="skeleton-shimmer skeleton-line-subtitle w-50"></div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section>
        </div>
    )
}

export default SkillArea